import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { advanceFlow, closeBirthChartFlow, getBirthChartFlow, patchFlowDetails } from '../../../../store/slices/birthChartSlice';
import { gaEvents } from '../../../../utils/analytics';
import { to24Hour } from '../../../../utils/birthInfo';
import BirthTimePicker from '../../../common/BirthTimePicker';
import Button, { BUTTON_STYLE_TYPE } from '../../../common/Button';
import Sheet from './Sheet';
import { firstMissingStep, timeToWheel } from './flowLogic';
import styles from './styles.module.scss';

const pad = (n) => String(n).padStart(2, '0');

const TimeSheet = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { details } = useSelector(getBirthChartFlow);

    const initial = useMemo(() => timeToWheel(details.birthTime), []); // eslint-disable-line react-hooks/exhaustive-deps
    const [hour, setHour] = useState(initial.hour);
    const [minute, setMinute] = useState(initial.minute);
    const [meridiem, setMeridiem] = useState(initial.meridiem);

    const complete = (patch) => {
        dispatch(patchFlowDetails(patch));
        gaEvents.bcStepCompleted('time');
        dispatch(advanceFlow(firstMissingStep({ ...details, ...patch })));
    };

    const handleContinue = () => complete({ birthTime: `${pad(to24Hour(hour, meridiem))}:${pad(minute)}`, birthTimeKnown: true });

    // Noon is applied server-side when the time is unknown.
    const handleUnknown = () => complete({ birthTime: null, birthTimeKnown: false });

    return (
        <Sheet
            title={t('birthChart.flow.time.title')}
            onClose={() => dispatch(closeBirthChartFlow())}
            closeLabel={t('birthChart.flow.close')}
        >
            <BirthTimePicker
                hour={hour}
                minute={minute}
                meridiem={meridiem}
                onHourChange={setHour}
                onMinuteChange={setMinute}
                onMeridiemChange={setMeridiem}
            />
            <Button
                styleType={BUTTON_STYLE_TYPE.PURPLE}
                extraClasses={[styles.cta]}
                text={t('birthChart.flow.continue')}
                onClick={handleContinue}
            />
            <button type="button" className={styles.linkButton} onClick={handleUnknown}>
                {t('birthChart.flow.time.unknown')}
            </button>
        </Sheet>
    );
};

export default TimeSheet;
